import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Button, DialogActions, DialogContent, DialogContentText, Radio } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setCloseDialogCC } from 'utils/helpers';
import { DIALOG_ID } from './constant';
import DialogBaseCC from './DialogBaseCC';


const DialogConfirmUpdate = () => {
    const { t } = useTranslation();
    const [selectedValue, setSelectedValue] = useState('a');
    const propsDialog = useLegacyDialogProps();
    const { tsStart, roomName, handleActionConfirmUpdate} = propsDialog

    const handleChange = (value) => {
        setSelectedValue(value);
    };

    return (
        <DialogBaseCC id={DIALOG_ID.CONFIRM_UPDATE} title={t('room.pop-up.update.title')}>
            <DialogContent>
                <DialogContentText>
                    <div className="row" style={{marginTop: '15px'}}>
                        <div className="col-md-12" style={{fontWeight: '700'}}>{t('room.pop-up.update.text1')}</div>
                        <div className="col-md-12" style={{ display: 'flex', alignItems: 'center' }}>
                            <Radio
                                checked={selectedValue === 'a'}
                                onChange={(e) => handleChange(e.target.value)}
                                value="a"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'A' }}
                                label={`${t('room.pop-up.update.text2')} ${moment.unix(tsStart).format('DD/MM/YYYY')}`}
                            />
                            <div style={{ cursor: 'pointer' }} onClick={() => handleChange('a')}>
                                {t('room.pop-up.update.text2')} <span style={{fontWeight: '700'}}>{moment.unix(tsStart).format('DD/MM/YYYY')}</span>
                            </div>
                        </div>
                        <div className="col-md-12" style={{ display: 'flex', alignItems: 'center' }}>
                            <Radio
                                checked={selectedValue === 'b'}
                                onChange={(e) => handleChange(e.target.value)}
                                value="b"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'B' }}
                                label={`${t('room.pop-up.update.text3')}`}
                            />
                            <div style={{ cursor: 'pointer' }} onClick={() => handleChange('b')}>
                                {t('room.pop-up.update.text3')} <span style={{fontWeight: '700'}}>{roomName}</span> {t('room.pop-up.update.text4')}
                            </div>
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => setCloseDialogCC()}>
                    {t('room.pop-up.update.cancel')}
                </Button>
                <Button 
                    onClick={() => {
                        setCloseDialogCC()
                        handleActionConfirmUpdate(selectedValue)
                    }}
                >
                    {t('room.pop-up.update.save')}
                </Button>
            </DialogActions>
        </DialogBaseCC>
    );
};

export default DialogConfirmUpdate;
